/*
 *  -----------------------------------------------------------------------
 *    <copyright file="reports/study-review.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { useState } from 'react';

import { useTranslation } from 'hooks';
import Constants from 'utils/constants';
import { validateFields } from 'utils/validation';
import CharactersRemaining from 'views/components/core/characters-remaining';
import ItemWrapper from 'views/components/core/item-wrapper';
import TextField from 'views/components/core/text-field';
import './styles.scss';

const StudyReview = ({
    state,
    setSiteReviewInfo,
    stateForGenerate,
    reportData,
    onUpdateErrorState,
    siteReviewInfo,
}: {
    state: any;
    setSiteReviewInfo: Function;
    stateForGenerate: any;
    reportData: any;
    onUpdateErrorState: Function;
    siteReviewInfo: any;
}) => {
    const { t } = useTranslation();

    const [reviewSummaryError, setReviewSummaryError] = useState(null);

    const reviewSummary =
        siteReviewInfo?.summary ?? reportData?.centralMonitoringReviewData?.studyReview.reviewSummary ?? '';

    return (
        <ItemWrapper title={t('cm:studyReview')} hideItemNumber>
            <div className="study-summary-wrapper">
                <p className="text-wrap">
                    <p className="title">{t('reports:reviewer')}:</p> {state.studyReview?.reviewer}
                </p>
                <p className="text-wrap">
                    <p className="title">{t('cm:reviewStartDate')}:</p> {state.studyReview?.reviewStartDate}
                </p>
                <p className="text-wrap">
                    <p className="title">{t('cm:reviewCompleteDate')}:</p> {state.studyReview?.reviewCompleteDate}
                </p>
            </div>
            <TextField
                label={t('cm:reviewSummary')}
                id="review-summary"
                rows={4}
                fullWidth
                multiline
                value={reviewSummary}
                onChange={(event: any) => {
                    setSiteReviewInfo(Constants.ObjectId.Empty, {
                        summary: event.target.value,
                        reviewer: state.studyReview.reviewer ?? '',
                        reviewed: state.studyReview.reviewed,
                        startDate: state.studyReview.reviewStartDate || null,
                        completedDate: state.studyReview.reviewCompleteDate || null,
                        siteId: Constants.ObjectId.Empty,
                        dataSetId: stateForGenerate.dataset.id,
                    });

                    const errorSummary = validateFields(event.target.value, 'reviewSummary', 1000, false);

                    onUpdateErrorState(Constants.ObjectId.Empty, errorSummary.reviewSummary);
                    setReviewSummaryError(errorSummary.reviewSummary);
                }}
                size="small"
                placeholder={t('enterText')}
                variant="outlined"
                color="secondary"
                helperText={
                    <CharactersRemaining
                        id="review-summary-text"
                        length={reviewSummary.length}
                        max={1000}
                        error={reviewSummaryError}
                    />
                }
                className="grey-color-label"
            />
        </ItemWrapper>
    );
};

export default StudyReview;
